import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, dialog, details, grid, markdown } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { editIcon, deleteIcon, addIcon, close, clock, address, web, provisionIcon, yellowTick, expandIcon, collapseIcon, calendar, arrowBack, binIcon } from '../../utilities/icons';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, getUrlFromFileId, validateURL, validateURLDirect, validatePhone, releaseFormLockwithBeacon, languages } from '../../utilities/formsUtilities';
import { processEventData, dateToMaybeRange, eventTypes, formatDateString, currencyFormatter } from '../../utilities/eventUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
import { AllInConditionals } from '../Utilities/AllInConditionals';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInOrganisationEventForm extends AllInConditionals(AllInOrganisationConsumer(LitElement)) {
    static properties = {
        currentOrg: { type: String, reflect: true },
        name: { type: String },
        event: { type: String },
        view: { type: String },
        _eventData: { state: true, type: Array },
        _eventDataProcessed: { state: true, type: Array },
        _provisionData: { state: true, type: Object },
        _isFormLocked: { state: true, type: Boolean },
        _eventProvisionsKeyed: { state: true, type: Object },
        currentFormat: { type: String },
        _touringLocationSelected: { type: Boolean, state: true },
        _touringLocation: { type: Object, state: true },
        _noLocationFound: { type: Boolean, state: true },
    };
    constructor() {
        super();
        this._provisions = [];
        this._locData = [];
        this._provisionData = {};
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    async connectedCallback() {
        super.connectedCallback();
        if (!this.event) {
            this.formID = null;
        }
        else {
            this.formID = `${this.event}-event-form`;
        }
        this.uid = `event-form-${this.organisationData.user.id}`;
        await this._setEventData();
        this.renderRoot.querySelector('a')?.focus();
        this.eventManager.listen(`allin-event-go-back-${this.name}`, this._handleGoBack);
        this.eventManager.listen(`location-selected-${this.name}`, (e) => { this._touringLocation = e.detail; });
        this.eventManager.listen(`no-location-found-${this.name}`, () => { this._noLocationFound = true; });
        const formatField = this._eventDataProcessed?.find((v) => { return v.name == 'format'; })?.value;
        //console.log("FormatFiled: "+formatField);
        //console.log("Event Data Processed: ",this._eventDataProcessed);
        this.currentFormat = formatField ?? 'InPerson';
        let hasLocations = this.organisation?.locations.length > 0;
        let hasApprovedLocations = hasLocations && this.organisation?.locations.some(loc => loc.location_data.approvalStatus === 'Approved');
        if (!hasLocations || !hasApprovedLocations) {
            const allowedFormats = ['Online', 'Touring'];
            if (!allowedFormats.includes(this.currentFormat)) {
                this.currentFormat = 'Online';
            }
        }
        if (!this._eventData?.format && (this._eventData?.locationName || this._eventData?.locationUrl) && this._eventData?.isLocationWithEventOrg == false) {
            this.currentFormat = 'Touring';
            if (this._eventData.locationUrl || this._eventData.locationName) {
                this._touringLocationSelected = true;
                this._noLocationFound = true;
            }
        }
        if ((this._eventData?.locationName || this._eventData?.locationUrl) && this._eventData?.format !== 'Online') {
            this.currentFormat = 'Touring';
            this._touringLocationSelected = true;
            this._noLocationFound = true;
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID, this.uid, this.restUrl, this.nonce);
    }
    async firstUpdated() {
        if (this.formID) {
            this._isFormLocked = await checkFormLock(this.formID, this.uid, this.restUrl, this.nonce);
            addEventListener('visibilitychange', (event) => {
                if (document.visibilityState === 'hidden') {
                    releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
                }
            });
        }
    }
    async updated(changedProperties) {
        if (changedProperties.has('view')) {
            if (this.view == 'edit') {
                lockForm(this.formID, this.uid, this.restUrl, this.nonce);
                this.renderRoot.querySelector('input')?.focus();
                if (this._eventData && this._eventData.hasOwnProperty('location') && this._eventData.location && this._eventData.location.id) {
                    if (this._eventData.isLocationWithEventOrg == false) {
                        this._handleLocationChange(this._eventData.location.id, true, this._eventData.location);
                    }
                    else {
                        this._handleLocationChange(this._eventData.location.id, true);
                    }
                }
            }
            else {
                this.renderRoot.querySelector('a')?.focus();
            }
            if (this.view) {
                this.message = '';
            }
        }
        if (changedProperties.has('_eventData') && this._eventData && this._form) {
            if (this._eventData.hasOwnProperty('location') && this._eventData.location && this._eventData.location.id) {
                if (this._eventData.isLocationWithEventOrg == false) {
                    this._handleLocationChange(this._eventData.location.id, true, this._eventData.location);
                }
                else {
                    this._handleLocationChange(this._eventData.location.id, true);
                }
            }
        }
        if (changedProperties.has('_touringLocation')) {
            if (this._touringLocation) {
                this._handleLocationChange(this._touringLocation.id, true, this._touringLocation);
            }
            else {
                this._handleLocationChange('touring_location', true);
            }
        }
    }
    /* <button id="zone" class="btn change_view ${this.view=='zone'?'active':''}" disabled aria-pressed="${this.view=='zone'?'true':'false'}">
        ${msg('Manage zones. Coming soon')}
    </button>  */
    render() {
        const isActive = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) > new Date();
        let main = '';
        let navigation = html `<div class="buttons">\n                <button id="${this.view == 'edit' ? 'details' : 'edit'}" class="btn change_view ${!this.view || this.view == 'edit' ? 'active' : ''}" @click=${this._handleChangeView} aria-pressed="${!this.view || this.view == 'edit' ? 'true' : 'false'}">\n                    Event details\n                </button>\n                \n                <button id="preview" class="btn change_view ${this.view == 'preview' ? 'active' : ''}" @click=${this._handleChangeView} aria-pressed="${this.view == 'preview' ? 'true' : 'false'}">\n                    Preview your event listing\n                </button>\n            </div>\n            `;
        if (this._eventData?.status == 'Archived' || this.view == 'add') {
            navigation = '';
        }
        if (!this._eventDataProcessed || this._eventDataProcessed.length == 0) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else if (this.panel == 'add' || this.view == 'add') {
            main = this._getEventForm('add', this._eventDataProcessed, navigation);
        }
        else if (isActive && (this.panel == 'edit' || this.view == 'edit')) {
            main = this._getEventForm('edit', this._eventDataProcessed, navigation);
        }
        else if (this.panel == 'preview' || this.view == 'preview') {
            main = html `\n                <h3>${decodeEntities(this._eventData.name)} details</h3>\n                ${navigation}\n                <div class="preview--container">\n                    <allin-event event="${this._eventData.id}" eventData="${JSON.stringify(this._eventData)}" organisation="${this.currentOrg}" preview="true" name="${this.name}" action="${this.action}" nonce="${this.nonce}" restUrl="${this.restUrl}" .hardlinks=${this.hardlinks}/>\n                </div>\n            `;
        }
        else if (this._eventData) {
            let cta = html `<hr><a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Edit these details</a>`;
            //let ctaDelete = html `<button class="delete-btn" @click=${this._openDeleteDialog}>${msg(`Delete this event`)}</button>` ;
            if (!isActive) {
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>Your subscription has expired. You can view this event, but you cannot edit or publish it until you renew your subscription.</p>\n                    </div>\n                    <a href="javascript:void(0)" @click=${(e) => { e.preventDefault(); this._updateContext({ dashboard: 'subscriptions', panel: '' }); }}>Renew Subscription</a>\n                `;
            }
            else if (this._eventData?.status == 'Draft') {
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>This event is in draft mode</p>\n                    </div>\n                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Edit event</a>\n                `;
            }
            else if (this._eventData?.status == 'Archived') {
                cta = html `\n                    <hr>\n                    <div class="message notice" aria-live="polite">\n                        <p>This event is archived</p>\n                    </div>\n                    `;
                //ctaDelete = html `<button class="delete-btn" @click=${this._backToAllEvents}>${msg(`Back to all events`)}</button>` ;
            }
            let loop = [];
            let name = this._eventData.name;
            let dateString = '';
            if (this._eventData.hasOwnProperty('firstInstance')) {
                let firstInstance = this._eventData.firstInstance;
                let lastInstance = '';
                if (this._eventData.hasOwnProperty('lastInstance')) {
                    lastInstance = this._eventData.lastInstance;
                }
                dateString = dateToMaybeRange(firstInstance.start, lastInstance.start);
            }
            if (dateString) {
                loop.push(html `<div class="grid grid--icon">\n                        <div class="icon">${calendar}</div>\n                        <div class="icon_text">\n                            <p><strong>Date:</strong></p>\n                            <p>${dateString}</p>\n                        </div>\n                    </div>`);
            }
            if (this._eventData.location && this._eventData.location.name) {
                loop.push(html `<div class="item grid grid--icon">\n                        <div class="icon">${address}</div>\n                        <div class="text">\n                            <p><strong>Location:</strong></p>\n                            <p>${this._eventData.location.name}</p>\n                        </div>\n                    </div>`);
            }
            //check if locationName&&!location, show the same as normal location
            let touringLocationName = this._eventDataProcessed.find((item) => item.name == 'locationName');
            if (touringLocationName?.value) {
                if (this._eventData.locationName && !this._eventData.location) {
                    loop.push(html `<div class="item grid grid--icon">\n                        <div class="icon">${address}</div>\n                        <div class="text">\n                            <p><strong>Location:</strong></p>\n                            <p>${touringLocationName?.value}</p>\n                        </div>\n                    </div>`);
                }
            }
            let accessLinkD = this._eventDataProcessed.find((item) => item.name == 'locationUrl');
            if (accessLinkD?.value) {
                loop.push(html `<div class="item grid grid--icon">\n                    <div class="icon">${web}</div>\n                    <div class="text"><p><strong>Access information:</strong></p>\n                    <p><a href="${accessLinkD.value}" target="_blank" rel="noopener">${accessLinkD.value}</a></p>\n                </div>`);
            }
            let bookingLinkD = this._eventDataProcessed.find((item) => item.name == 'defaultBookingLink');
            //console.log('Initial value: ' + bookingLinkD?.value);
            // Fix by updating the value property
            if (bookingLinkD) {
                bookingLinkD.value = decodeEntities(this._eventData?.defaultBookingLink ?? '');
            }
            //console.log('Fixed value: ' + bookingLinkD?.value);
            if (bookingLinkD.value) {
                loop.push(html `<div class="item grid grid--icon">\n                        <div class="icon">${web}</div>\n                        <div class="text">\n                            <p><strong>Booking link:</strong></p>\n                            <p><a href="${bookingLinkD.value}" target="_blank" rel="noopener">${bookingLinkD.value}</a></p>\n                        </div>\n                    </div>`);
            }
            let languageD = this._eventDataProcessed.find((item) => item.name == 'language');
            if (languageD?.value) {
                loop.push(html `<div class="item text">\n                        <p><strong>Language:</strong></p>\n                        <p>${languages[languageD.value]}</p>\n                    </div>`);
            }
            let priceLowD = this._eventDataProcessed.find((item) => item.name == 'priceRangeLow');
            let priceHighD = this._eventDataProcessed.find((item) => item.name == 'priceRangeHigh');
            if (priceLowD.value || priceHighD.value) {
                let priceRange = '';
                if (priceLowD.value && priceHighD.value) {
                    priceRange = `${currencyFormatter.format(priceLowD.value)} - ${currencyFormatter.format(priceHighD.value)}`;
                }
                else if (priceLowD.value) {
                    priceRange = `From ${currencyFormatter.format(priceLowD.value)}`;
                }
                else if (priceHighD.value) {
                    priceRange = `Up to ${currencyFormatter.format(priceHighD.value)}`;
                }
                loop.push(html `<div class="item text">\n                    <p><strong>Price range:</strong></p>\n                    <p>${priceRange}</p>\n                </div>`);
            }
            let descriptionD = this._eventDataProcessed.find((item) => item.name == 'description');
            if (descriptionD.value) {
                loop.push(html `<div class="item text">\n                        <p><strong>Description:</strong></p>\n                        <allin-markdown-editor readonly value="${decodeEntities(descriptionD.value)}"></allin-markdown-editor>\n                    </div>`);
            }
            let typeD = this._eventDataProcessed.find((item) => item.name == 'type');
            if (typeD.value && typeD.value.length > 0) {
                let types = typeD.value.map((type) => {
                    let typeData = eventTypes.find((t) => t.name === type);
                    return typeData ? typeData.label : type;
                });
                loop.push(html `<div class="item text">\n                        <p><strong>Type:</strong></p>\n                        <p>${types.join(', ')}</p>\n                    </div>`);
            }
            let photo1D = this._eventDataProcessed.find((item) => item.name == 'photo1');
            let photo2D = this._eventDataProcessed.find((item) => item.name == 'photo2');
            let photo3D = this._eventDataProcessed.find((item) => item.name == 'photo3');
            if (photo1D.value || photo2D.value || photo3D.value) {
                loop.push(html `<p><strong>Gallery</strong></p>`);
                if (photo1D.value && photo1D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo1D.value.publicUrl}" alt="${photo1D.value.altText}" width="200px" />\n                            <div class="text">\n                                <p><strong>ALT text</strong></p>\n                                <p>${photo1D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
                if (photo2D.value && photo2D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo2D.value.publicUrl}" alt="${photo2D.value.altText}" width="200px" />\n                            <div class="text">\n                                <p><strong>ALT text</strong></p>\n                                <p>${photo2D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
                if (photo3D.value && photo3D.value.hasOwnProperty('publicUrl')) {
                    loop.push(html `\n                        <div class="item grid grid--image">\n                            <img src="${photo3D.value.publicUrl}" alt="${photo3D.value.altText}" width="200px" />\n                            <div class="text">\n                                <p><strong>ALT text</strong></p>\n                                <p>${photo3D.value.altText}</p>\n                            </div>\n                        </div>`);
                }
            }
            let instances = this._eventData.instances;
            let instancesLoop = [];
            if (instances && instances.length > 0) {
                instancesLoop = instances.map((item) => {
                    let date = formatDateString(item.start);
                    let endDate = item?.end ? formatDateString(item.end) : '';
                    let bookingLink = item?.bookingLink ? item.bookingLink : '';
                    if (bookingLink) {
                        bookingLink = validateURLDirect(bookingLink);
                    }
                    return html `<li>\n                        <dl>\n                            <dt>Start</dt>\n                            <dd>${date}</dd>\n                            ${endDate ? html `<dt>End</dt>\n                            <dd>${endDate}</dd>` : ''}\n                            ${bookingLink ? html `<dt>Booking link</dt>\n                            <dd><a href="${bookingLink}" target="_blank">View booking</a></dd>` : ''}\n                            ${item.zone ? html `<dt>Zone</dt><dd>${item.zone.name}</dd>` : ''}\n                            ${item.provisions && item.provisions.length > 0 ? html `<dt>Provisions</dt>\n                            <dd>${item.provisions.map(provision => { return html `<h4>${this._eventProvisionsKeyed[provision.standardId]?.name}</h4><allin-markdown-editor readonly value="${provision.description}"></allin-markdown-editor>`; })}</dd>` : ''}\n                        </dl>\n                    </li>`;
                });
            }
            if (instancesLoop.length > 0) {
                instancesLoop = html `<div class="item"><p><strong>Instances</strong></p><ul class="instances">${instancesLoop}</ul></div>`;
            }
            main = html `\n                <h3>${decodeEntities(name)} details</h3>\n                ${navigation}\n                <div class="message notice" aria-live="polite">\n                    ${this.message ? html `<p>${this.message}</p>` : ''}\n                </div>\n                <div class="bg">\n                    ${loop}\n                    ${instancesLoop}\n                    <div class="cta-wrapper">\n                        ${cta}\n                    </div>\n                </div>\n            `;
        }
        else {
            main = html `<allin-loader loading></allin-loader>`;
        }
        return html `\n            ${main}\n\n            <dialog class="delete-dialog">\n                <h3>Delete event</h3>\n\n                <p>\n                    You are about to permanently delete this event. This action cannot be reversed.\n                </p>\n\n                <div class="buttons">\n                    <button\n                        type="button"\n                        @click=${this._closeDeleteDialog}\n                    >\n                        Cancel\n                    </button>\n\n                    <button\n                        type="button"\n                        class="danger"\n                        @click=${this._handleDeleteEvent}\n                    >\n                        Delete\n                    </button>\n                </div>\n            </dialog>\n        `;
    }
    _openDeleteDialog() {
        const dialog = this.renderRoot.querySelector('.delete-dialog');
        dialog?.showModal();
    }
    _closeDeleteDialog() {
        const dialog = this.renderRoot.querySelector('.delete-dialog');
        dialog?.close();
    }
    async _handleDeleteEvent() {
        this._closeDeleteDialog();
        try {
            const response = await fetch(this.restUrl, {
                method: 'POST',
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    action: 'org-dashboard-delete-event',
                    org_id: this.currentOrg,
                    event_id: this._eventData.id,
                }),
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const result = await response.json();
            if (!result.ok) {
                console.error(result.message || 'Failed to archive event');
                return;
            }
            // update local UI ONLY AFTER success
            this._eventData = {
                ...this._eventData,
                status: 'Archived'
            };
            // refresh list from server so UI stays consistent
            //await this._fetchEvents();
            this.eventManager.emit(`allin-organisation-${this.name}-refresh-events`);
            this._updateContext({
                panel: '',
            });
        }
        catch (err) {
            console.error('Archive event failed:', err);
        }
    }
    _backToAllEvents(e) {
        e.preventDefault();
        window.location.href =
            `/organisation-dashboard/${this.currentOrg}/events`;
    }
    _handleClick(e) {
        e.preventDefault();
        this.view = this.view == 'edit' ? '' : 'edit';
    }
    _handleGoBack() {
        this._handleChangeView(null, '');
        this.eventManager.emit(`allin-navigation-reset-${this.name}`, { 'path': 'events' });
    }
    _handleChangeView(e, view = null) {
        if (e) {
            e.preventDefault();
            let button = e.target;
            view = button.id;
            if (view == 'edit') {
                view = '';
            }
        }
        let oldView = this.view;
        this.view = view;
        if (this.view == oldView) {
            return;
        }
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/events/' + this.event + '/' + this.view, { panel: this.event, view: this.view });
        if (this.view) {
            let name = '';
            if (this.view == 'add') {
                let crumb = {
                    //organisation:{url:`/organisation-dashboard/${this.currentOrg}/`,title:msg(`Dashboard`)},
                    organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: this.organisation?.name },
                    dashboard: { url: `/organisation-dashboard/${this.currentOrg}/events/`, title: `Manage Events` },
                    view: { url: `/organisation-dashboard/${this.currentOrg}/events//${this.view}`, title: `Add an event` }
                };
                this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
                return;
            }
            else if (this.view == 'preview') {
                name = `Listing view`;
            }
            let crumb = {
                //organisation:{url:`/organisation-dashboard/${this.currentOrg}/`,title:msg(`Dashboard`)},
                organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: this.organisation?.name },
                dashboard: { url: `/organisation-dashboard/${this.currentOrg}/events/`, title: `Manage Events` },
                panel: { url: `/organisation-dashboard/${this.currentOrg}/events/${this.event}/`, title: this._eventData.name },
                view: { url: `/organisation-dashboard/${this.currentOrg}/events/${this.event}/${this.view}`, title: name }
            };
            this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        }
    }
    _getEventForm(view, eventData, navigation = '') {
        let main;
        if (this._setEventData && this._isFormLocked) {
            main = html `\n                <h3>${decodeEntities(eventData.name)} details</h3>\n                ${navigation}\n                <div class="bg">\n                    <div class="message notice" aria-live="polite">\n                        <p>This form is currently being edited by another member of this organisation</p>\n                    </div>\n                </div>\n            `;
        }
        else {
            let title = view == 'add' ? 'Add a new event' : `${'Edit event'} ${decodeEntities(this._eventData.name)}`;
            let multiloader = html `<allin-multiloader buttontext="Add an image">\n                <h3>Upload an image for your event</h3>\n                <p class="small">You can upload images to appear on your event listing.</p>\n                ${eventData.map((item, i) => {
                if (item.type !== 'file')
                    return '';
                let show = i === 0 || item.value ? 'show' : '';
                let fileId = '';
                if (item.value?.publicUrl) {
                    let pattern = /%2f([^%]*)%2f/gi;
                    let matches = pattern.exec(item.value.publicUrl);
                    if (matches && matches[1]) {
                        fileId = matches[1];
                    }
                }
                return html `\n                    <div class='group ${show}'>\n                        <div class="input-group">\n                            <allin-image-uploader inputname="${item.name}" label ="Upload an location photo" src="${item.value?.publicUrl}" labelalt="${item.name}" id="${item.name}" altrequired="${item.name}AltText" altinput="${fileId}" removeStyle="words">\n                            </allin-image-uploader>\n                            <label for="${item.name}AltText">Please include alt text</label>\n                            <a href="https://design102.blog.gov.uk/2022/01/14/whats-the-alternative-how-to-write-good-alt-text/" target="_blank">View a guide on how to write alt text (opens in a new tab)</a>\n                            <input type="text" name="${item.name}AltText" id="${item.name}AltText" data-label="${item.name} ALT text" data-table_label="ALT text " value="${item.value?.altText}">\n                        </div>\n                    </div>`;
            })}\n            </allin-multiloader>`;
            let reorderedEventData = [...eventData];
            const nameIndex = reorderedEventData.findIndex(i => i.name === 'language');
            const formatIndex = reorderedEventData.findIndex(i => i.name === 'format');
            if (nameIndex !== -1 && formatIndex !== -1 && formatIndex !== nameIndex + 1) {
                const [formItem] = reorderedEventData.splice(formatIndex, 1);
                reorderedEventData.splice(nameIndex + 1, 0, formItem);
            }
            let ctaDelete = view !== 'add' ? html `<button type="button" class="delete-btn" @click=${this._openDeleteDialog}>${binIcon}Delete this event</button>` : '';
            main = html `\n                <h3>${title}</h3>\n                ${navigation}\n                <form @submit=${this._handleSubmit}>\n                    <div class="message notice" aria-live="polite">\n                    </div>\n                    <div class="bg">\n                        \n                            ${reorderedEventData.map((item) => {
                if (item.name === 'locationName') {
                    return '';
                }
                let input = '';
                if (item.type == 'file') {
                    return '';
                }
                if (item.type == 'multiloader') {
                    return multiloader;
                }
                if (item.type == 'checkbox') {
                    input = html `<input type="${item.type}" id="${item.name}" name="${item.name}" ?checked=${item.value} />`;
                }
                else if (item.type == 'multiselect') {
                    input = html `<allin-multiselect name='${item.name}' list='${JSON.stringify(item.options)}' value='${JSON.stringify(item.value)}' required data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}"></allin-multiselect>`;
                }
                else if (item.type == 'textarea') {
                    //input = html`<textarea name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="Description" maxlength="500" placeholder="${msg(`Description`)}">${decodeEntities(item.value)}</textarea>`; 
                    input = html `<allin-markdown-editor name="${item.name}" id="${item.name}" data-label="${item.labelalt}" labelalt="${item.title}" description="Description" maxlength="500" placeholder="Description" value="${decodeEntities(item.value)}" ?required="${item.required}" data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}"></allin-markdown-editor>`;
                }
                else if (item.type == 'select') {
                    if (item.name === 'format') {
                        let hasLocations = this.organisation?.locations.length > 0;
                        let hasApprovedLocations = hasLocations && this.organisation?.locations.some(loc => loc.location_data.approvalStatus === 'Approved');
                        if (!hasLocations || !hasApprovedLocations) {
                            item.options = item.options.filter(option => option.value == 'Online' || option.value == 'Touring');
                        }
                        input = html `\n                                            <select name="format" id="format" @change=${this._handleFormatChange}>\n                                                ${item.options.map(option => html `\n                                                    <option value="${option.value}" ?selected=${this.currentFormat === option.value}>${option.label}</option>\n                                                `)}\n                                            </select>\n                                        `;
                    }
                    else if (item.name == 'locationId') {
                        let locationLabel = item.title;
                        if (this.eventIsOnline) {
                            locationLabel = `Please add a link to the access information page for your online event`;
                            input = html `\n                                                <label for="locationUrl">${locationLabel}${item.hasOwnProperty('required') ? '*' : ''}</label>\n                                                <input type="url" id="locationUrl" name="locationUrl" placeholder="${locationLabel}" value="${decodeEntities(this._eventData?.locationUrl ?? '')}" aria-required="true" data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}" @blur=${this._slotURLChangeOnline}/>\n                                                <input type="hidden" name="locationId" value="" />\n                                            `;
                        }
                        else if (this.eventIsTouring) {
                            input = '';
                        }
                        else {
                            input = html `\n                                            <label for="${item.name}">${locationLabel}${item.hasOwnProperty('required') ? '*' : ''}</label>\n                                            ${item.description ? html `<p class="small">${item.description}</p>` : ''}\n                                            <select name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="${item.title}" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''} @change=${(e) => { let locationId = e.target.value; this._handleLocationChange(locationId); }} data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}">\n                                                <option value="">Please select</option>\n                                                ${item.options.map((option) => { return html `<option value="${option.value}" ?selected=${option.value === item.value}>${option.label}</option>`; })}\n                                            </select>`;
                        }
                    }
                    else if (item.name == 'status') {
                        if (this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) > new Date()) {
                            input = html `<select name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="${item.title}" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''}>\n                                                <option value="">Please select</option>\n                                                ${item.options.map((option) => { return html `<option value="${option.value}" ?selected=${option.value === item.value}>${option.label}</option>`; })}\n                                            </select>`;
                        }
                        else {
                            input = html `<p>You can publish events when you have an active subscription. Your event will be marked as a draft.</p>`;
                        }
                    }
                    else if (item.name == 'language') {
                        const label = this.org_events_language_texts?.event_language_label || item.title;
                        input = html `<select name="${item.name}" id="${item.name}" data-label="${label}" data-table_label="${label}" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''} data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}">\n                                            ${item.options.map((option) => { return html `<option value="${option.name}" ?selected=${option.name === item.value}>${option.label}</option>`; })}\n                                        </select>`;
                    }
                    else {
                        input = html `<select name="${item.name}" id="${item.name}" data-label="${item.title}" data-table_label="${item.title}" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''} data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}">\n                                            <option value="">Please select</option>\n                                            ${item.options.map((option) => { return html `<option value="${option.value}" ?selected=${option.value === item.value}>${option.label}</option>`; })}\n                                        </select>`;
                    }
                }
                else if (item.name == 'touringLocation') {
                    if (item.value) {
                        this._touringLocationSelected = true;
                    }
                    if ((this._touringLocationSelected || this._eventData?.locationUrl) && this.currentFormat !== 'Online' && this.currentFormat !== 'InPerson') {
                        input = html `\n                                        <allin-location-search name="${this.name}" restUrl="${this.restUrl}" locationUrl="${this._eventData?.locationUrl}" locationName="${this._eventData?.locationName}" nonce="${this.nonce}" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''} value="${item.value}"></allin-location-search>`;
                    }
                    else {
                        return html `<div aria-live="polite"></div>`;
                    }
                }
                else if (item.type == 'repeater') {
                    input = html `<allin-repeater name="${item.name}" id="${item.name}" values='${JSON.stringify(item.value ?? [])}' subfields='${JSON.stringify(item.subFields ?? [])}' ?isonline=${this.eventIsOnline} ?istouringnolocation=${this._touringLocationSelected && this._noLocationFound} label="${item.title}" tablelabel="${item.title}" buttontext="Add another date" buttontextnew="Add a date" isrequired></allin-repeater>`;
                }
                else if (item.type == 'number') {
                    input = html `<input type="${item.type}" id="${item.name}" name="${item.name}" value=${parseFloat(item.value)} min="0.00" step="any" ${item.hasOwnProperty('required') ? 'aria-required="true"' : ''} />`;
                }
                else if (item.name === 'defaultBookingLink') {
                    input = html `\n                                        <input\n                                            type="url"\n                                            id="defaultBookingLink"\n                                            name="defaultBookingLink"\n                                            value="${decodeEntities(this._eventData?.defaultBookingLink ?? '')}"\n                                            @change=${this._validateURL} \n                                        />\n                                    `;
                }
                else if (item.name === 'locationUrl') {
                    //in the form this is handled dynamically according to the format
                    return;
                }
                else if (item.hasOwnProperty('required')) {
                    input = html `<input @change=${this._validateURL} type="${item.type}" id="${item.name}" aria-required="true" name="${item.name}" value=${decodeEntities(item.value)} data-error_message="${item.error_message ? item.error_message : item.label + 'is required'}" />`;
                }
                else {
                    input = html `<input @change=${this._validateURL} type="${item.type}" id="${item.name}" name="${item.name}" value=${decodeEntities(item.value)} data-requiredif="${item.requiredIf}" />`;
                }
                return html `\n                                <div class="input-group" aria-live="polite">\n                                    ${!(item.type === 'select' && item.name === 'locationId')
                    ? html `<label for="${item.name}">${item.name === 'language' ? (this.org_events_language_texts?.event_language_label || item.title) : item.title}${item.hasOwnProperty('required') || item.type === 'repeater' ? '*' : ''}</label>` : ''}\n                                    ${!(item.type === 'select' && item.name === 'locationId') && (item.name === 'language' ? (this.org_events_language_texts?.event_language_sub_copy || item.description) : item.description)
                    ? html `<p class="small">${item.name === 'language' ? (this.org_events_language_texts?.event_language_sub_copy || item.description)
                        : item.description}</p>` : ''}\n                                    ${input}\n                                </div>\n                            `;
            })} \n                            <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                            <input type="hidden" name="event_id" value="${this.event}" />\n                            <input type="hidden" name="action" value="${this.action}-edit-event" />\n                            <div class="button-group">\n                                <button type="submit">Submit</button>\n                            </div>   \n                            <hr>\n                            <div class="cta-wrapper">\n                                <a href="javascript:void(0)" @click=${this._handleClick}>${deleteIcon}Cancel</a>\n                                ${ctaDelete} \n                            </div>\n                    </div>\n                </form> \n            `;
        }
        return main;
    }
    async _handleSubmit(e) {
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');
        // Do not require zones if event is ONLINE
        if (this.eventIsOnline) {
            this._form
                .querySelectorAll('select[data-name="zoneId"]')
                .forEach(select => {
                select.removeAttribute('required');
                select.removeAttribute('aria-required');
            });
        }
        let valid = validateForm(this._form, formResponse);
        if (!valid) {
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        if (!this._eventData?.locationId && (this._eventData?.locationUrl || this._eventData?.locationName) && this._eventData?.format !== 'Online') {
            formData.set('format', 'Touring');
        }
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (!response.error) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                let eventData = JSON.parse(response.data);
                if (!this.organisation.hasOwnProperty('events')) {
                    this.organisation.events = {};
                }
                this.organisation.events[eventData.id] = eventData;
                this.event = eventData.id;
                await this._setEventData();
                submitButton.disabled = false;
                if (this.panel == 'add') {
                    this.message = 'This event has been created. Please go to "Manage event" to see your events ';
                }
                else {
                    this.message = 'Your changes have been saved';
                }
                this.panel = '';
                this._updateContext({ organisation: this.organisation, panel: this.panel });
            }
            else {
                formResponse.innerHTML = response.message || 'An error occurred';
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        }
        ;
    }
    get eventIsOnline() {
        return String(this.currentFormat).trim().toLowerCase() === "online";
    }
    get eventIsTouring() {
        return this._touringLocationSelected || String(this.currentFormat).trim().toLowerCase() === "touring";
    }
    _handleLocationChange(locationId, init = false, touringLocation = null) {
        let repeater = this._form.querySelector('allin-repeater');
        if (locationId && repeater) {
            let location;
            if (touringLocation) {
                location = touringLocation;
            }
            else {
                location = this.organisation.locations.find((loc) => loc.id == locationId);
            }
            if (locationId && !location) {
                console.error('Location not found for id:', locationId);
                return;
            }
            if (location) {
                let zones = location.location_data?.zones;
                if (!touringLocation) {
                    zones = zones.filter(zone => zone.approvalStatus == 'Approved');
                }
                if (zones && zones.length > 0) {
                    zones.unshift({ id: '', name: 'Select zone' });
                    let zoneOptions = zones.map((zone) => {
                        return { value: zone.id, label: zone.name };
                    });
                    repeater.zoneOptions = zoneOptions;
                    if (!init) {
                        repeater.querySelectorAll('select[data-name="zoneId"]').forEach((select) => {
                            select.value = '';
                        });
                    }
                }
                else {
                    repeater.zoneOptions = [];
                    if (!init) {
                        repeater.querySelectorAll('select[data-name="zoneId"]').forEach((select) => {
                            select.value = '';
                        });
                    }
                }
            }
        }
    }
    async _setEventData() {
        if (!this.organisation.locations) {
            await this._fetchLocations();
        }
        if (this.event && !this._getEventById(this.event)) {
            await this._fetchEvent(this.event);
        }
        if (!this.eventProvisions.length) {
            await this._fetchAllProvisions();
        }
        this._eventProvisionsKeyed = {};
        this.eventProvisions.forEach((provision) => {
            provision.provisions.forEach((p) => {
                this._eventProvisionsKeyed[p.id] = p;
            });
        });
        this._eventData = this._getEventById(this.event);
        this._eventDataProcessed = processEventData(this._eventData, this.organisation.locations, this.eventProvisions);
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    _getEventById(id) {
        let eId = this.organisation?.events?.hasOwnProperty(id) ? this.organisation.events[id] : null;
        return eId;
    }
    _handleFormatChange(e) {
        this.currentFormat = e.target.value; // <-- reactive update
        if (this.currentFormat == 'Touring') {
            this._touringLocationSelected = true;
        }
        else {
            this._touringLocationSelected = false;
        }
        if (this.currentFormat == 'Online') {
            if (this._eventData?.locationId) {
                this.eventData.locationId = '';
                this._handleLocationChange('', true);
            }
        }
    }
    async _fetchLocations() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-locations&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.organisation.locations = data.locations;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    async _fetchEvent(eventId) {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&event_id=${eventId}&action=${this.action}-event&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            if (data.event) {
                if (this.organisation.hasOwnProperty('events') == false) {
                    this.organisation.events = {};
                }
                if (this.organisation.events.hasOwnProperty(eventId)) {
                    let currentEventData = this.organisation.events[eventId];
                    let mergedEventData = { ...currentEventData, ...data.event };
                    this.organisation.events[eventId] = mergedEventData;
                }
                else {
                    this.organisation.events[eventId] = data.event;
                }
            }
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    async _fetchProvisions() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions&location_id=${this.location}&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this._locationData.provisions = data.provisions;
            this.organisation.locations.provisions = data.provisions;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    async _fetchAllProvisions() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions-events-all&nonce=${this.nonce}`;
        try {
            const response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            this.eventProvisions = data.eventProvisions;
            this._loading = false;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { eventProvisions: JSON.stringify(this.eventProvisions) });
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    _handleContextUpdate(value) {
        this.organisationData = value;
        ({ currentOrg: this.currentOrg, name: this.name, restUrl: this.restUrl, nonce: this.nonce, provisions: this._provisions } = this.organisationData);
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    _handleCollapse(e) {
        let target = e.currentTarget.dataset.collapse;
        if (target) {
            let targets = this.shadowRoot.querySelectorAll(`.${target}`);
            if (e.currentTarget.getAttribute('aria-expanded') == 'true') {
                e.currentTarget.setAttribute('aria-expanded', 'false');
                targets.forEach(target => target.classList.remove('open'));
            }
            else {
                e.currentTarget.setAttribute('aria-expanded', 'true');
                targets.forEach(target => target.classList.add('open'));
            }
        }
    }
    _validateURL(e) {
        if (e.target.type !== 'url')
            return;
        validateURL(e.target);
    }
    _slotURLChangeOnline(e) {
        const value = e.target.value?.trim();
        if (value && !/^https?:\/\//i.test(value)) {
            e.target.value = `https://${value}`;
        }
    }
    // New custom function to get Online event link data to be passed to allin-navigation
    _getSidebarLinks() {
        const links = [];
        // Online access link (only for Online events)
        if (this.eventIsOnline) {
            let accessLink = this._eventDataProcessed.find(item => item.name === 'locationUrl');
            if (accessLink) {
                accessLink.value = decodeEntities(this._eventData?.locationUrl ?? '');
                if (accessLink.value) {
                    links.push({ label: 'Online access link', url: accessLink.value });
                }
            }
        }
        return links;
    }
    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        markdown,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
            background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            font-weight: var(--allin-button-font-weight, 600);
            color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            box-sizing: border-box;
            overflow:visible;
            max-height:unset;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700px){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }
        
        .instances dl{
            display:grid;
            gap:0.5rem;
        }
        @media screen and (min-width:700px){
            .instances dl{
                grid-template-columns: max-content 1fr;
            }
        }
        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }

        .repeater{
            padding:0 0.5rem;
        }

        @media screen and (min-width:700px){
            .repeater{
                padding:0 2rem;
            }
        }
        allin-location-search .bg{
            background-color:var(--color-bg);
        }
        allin-location-search ul{
            list-style:none;
            padding:0;
            margin:1rem 0;
        }
        allin-location-search li, allin-location-search .selected-location{
            margin-bottom:0.5rem;
            display:grid;
            grid-template-columns: 3rem 1fr auto;
            gap:1rem;
            align-items:center;
            img{
                width:3rem;
                height:3rem;
                object-fit:cover;
            }
            button{
                height:fit-content;
            }
        }
        .searchboxes {
            display: grid;
            grid-template-columns: 1fr auto;
            width: 100%;
            max-width: 800px;
            margin-bottom: 2rem;
            position:relative;
        }

        .searchbox {
            position: relative;
            label {
                margin-bottom: 0.5rem;
            }
        }
        .searchbox svg {
            position: absolute;
            left: 0.5rem;
            bottom: 0.8rem;
            width: 1.5rem;
            height: 1.5rem;
        }

        .searchbox input{
            padding-left:2.5rem;
            border-radius:0.5rem 0 0 0.5rem;
        }
        .searchboxes button{
            border-radius:0 0.5rem 0.5rem 0;
            height:calc(3rem + 2px);
            align-self:end;
        }
        .no-location button{
            margin:1rem 0 0 auto;
            display:block;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        .cta-wrapper{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
            hr{
                flex-basis:100%;
            }
            .message.notice{
                flex-basis:100%;
            }
        }

        .cta-wrapper a{
            display: inline-flex;
            width: 50%;
        }
        .cta-wrapper button[type='button'].delete-btn{
            display: inline-flex;
            width: fit-content;
            gap: 0.5rem;
            background-color: transparent;
            text-decoration: none;
            color:var(--allin-highlight-color,#472961);
            font-weight: 700;
            font-size: 0.9rem;
        }
        .cta-wrapper button svg g path{
            fill:var(--allin-highlight-color,#472961);
        }
        .cta-wrapper button[type='button'].delete-btn:hover{
            text-decoration: underline;
        }
        .cta-wrapper div.message.notice{
            display: inline-block;
        }
        dialog.delete-dialog{
            padding: 2rem 2rem 1.5rem;
        }

        @media screen and (max-width:700px){
            .cta-wrapper a{
                width: 100%;
            }
            .cta-wrapper button{
                width: 100%;
                float: none;
                top: 1rem;
            }
        }

        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }
        `
    ];
}
